// src/pages/FacturacionPresupuestos/CarteraProveedoresTab.js
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { 
    FaTruckLoading, 
    FaPlus, 
    FaSearch, 
    FaEdit, 
    FaTrash, 
    FaWhatsapp, 
    FaTimes,
    FaBolt
} from 'react-icons/fa';
import './GestionTabs.css';

const GIROS_PROVEEDORES_INICIALES = [
    'Material Eléctrico e Iluminación',
    'Material de Video-vigilancia y CCTV',
    'Control de Acceso y Automatización (Motores, Barreras, Tags)',
    'Redes, Fibra Óptica y Telecomunicaciones',
    'Cerrajería y Herrería de Seguridad',
    'Hidráulica, Plomería y Bombas de Agua',
    'Pintura e Impermeabilización',
    'Mantenimiento General y Obra Civil',
    'Jardinería, Paisajismo y Sistemas de Riego',
    'Fumigación y Control de Plagas',
    'Software, Nube y Licenciamiento Tecnológico',
    'Equipos de Cómputo, Servidores y Conectividad'
];

const CarteraProveedoresTab = ({
    proveedores = [],
    onGuardarProveedor,
    onEliminarProveedor,
    onSembrarCatalogo
}) => {
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [proveedorEditando, setProveedorEditando] = useState(null);

    // Stock de Giros y Especialidades (Punto 9)
    const [girosStock, setGirosStock] = useState(() => {
        try {
            const saved = localStorage.getItem('facturacion_stock_giros_prov_v1');
            if (saved) return JSON.parse(saved);
        } catch (e) {}
        return GIROS_PROVEEDORES_INICIALES;
    });

    const [mostrarNuevoGiro, setMostrarNuevoGiro] = useState(false);
    const [nuevoGiroTexto, setNuevoGiroTexto] = useState('');
    const [editandoGiroIndex, setEditandoGiroIndex] = useState(null);

    const guardarStockGiros = (nuevos) => {
        setGirosStock(nuevos);
        try {
            localStorage.setItem('facturacion_stock_giros_prov_v1', JSON.stringify(nuevos));
        } catch (e) {}
    };

    const handleConfirmarGiro = () => {
        const texto = nuevoGiroTexto.trim();
        if (!texto) return;

        if (editandoGiroIndex !== null) {
            const actualizados = [...girosStock];
            actualizados[editandoGiroIndex] = texto;
            guardarStockGiros(actualizados);
            setFormProveedor(prev => ({ ...prev, giro: texto }));
            setEditandoGiroIndex(null);
        } else {
            if (!girosStock.includes(texto)) {
                const actualizados = [...girosStock, texto];
                guardarStockGiros(actualizados);
                setFormProveedor(prev => ({ ...prev, giro: texto }));
            }
        }
        setNuevoGiroTexto('');
        setMostrarNuevoGiro(false);
    };

    const handleIniciarEdicionGiro = () => {
        const actual = formProveedor.giro || girosStock[0];
        const idx = girosStock.findIndex(g => g === actual);
        if (idx !== -1) {
            setEditandoGiroIndex(idx);
            setNuevoGiroTexto(girosStock[idx]);
            setMostrarNuevoGiro(true);
        }
    };

    const handleEliminarGiroSeleccionado = async () => {
        if (girosStock.length <= 1) {
            Swal.fire({
                title: 'Giro Requerido',
                text: 'Debes conservar al menos un giro en el stock.',
                icon: 'warning',
                confirmButtonColor: '#ea580c'
            });
            return;
        }
        const actual = formProveedor.giro || girosStock[0];
        const res = await Swal.fire({
            title: '¿Eliminar Giro de Proveedor?',
            html: `¿Deseas eliminar el giro <strong>"${actual}"</strong> del catálogo?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#94a3b8',
            confirmButtonText: 'Sí, eliminar giro',
            cancelButtonText: 'Cancelar'
        });
        if (!res.isConfirmed) return;
        const actualizados = girosStock.filter(g => g !== actual);
        guardarStockGiros(actualizados);
        setFormProveedor(prev => ({ ...prev, giro: actualizados[0] || 'General' }));
        Swal.fire({
            title: 'Giro eliminado',
            text: `El giro "${actual}" ha sido removido del catálogo.`,
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
        });
    };

    const [formProveedor, setFormProveedor] = useState({
        nombre: '',
        rfc: '',
        giro: '',
        contacto: '',
        telefono: '',
        email: '',
        direccion: '',
        notas: ''
    });

    const abrirModal = (prov = null) => {
        if (prov) {
            setProveedorEditando(prov);
            setFormProveedor({
                nombre: prov.nombre || '',
                rfc: prov.rfc || '',
                giro: prov.giro || '',
                contacto: prov.contacto || '',
                telefono: prov.telefono || '',
                email: prov.email || '',
                direccion: prov.direccion || '',
                notas: prov.notas || ''
            });
        } else {
            setProveedorEditando(null);
            setFormProveedor({
                nombre: '',
                rfc: '',
                giro: '',
                contacto: '',
                telefono: '',
                email: '',
                direccion: '',
                notas: ''
            });
        }
        setModalAbierto(true);
    };

    const handleGuardar = (e) => {
        e.preventDefault();
        if (!formProveedor.nombre.trim()) {
            alert('Por favor especifica la Razón Social o Nombre del Proveedor.');
            return;
        }

        const data = {
            ...formProveedor,
            id: proveedorEditando?.id || Date.now().toString(),
            actualizadoEn: new Date().toISOString()
        };

        onGuardarProveedor(data);
        setModalAbierto(false);
    };

    const proveedoresFiltrados = proveedores.filter(p => {
        const texto = `${p.nombre || ''} ${p.rfc || ''} ${p.giro || ''} ${p.contacto || ''} ${p.email || ''}`.toLowerCase();
        return !busqueda || texto.includes(busqueda.toLowerCase());
    });

    return (
        <div className="gestion-tab-container">
            {/* Header */}
            <div className="gestion-tab-header">
                <div className="gestion-tab-title-group">
                    <h2>
                        <FaTruckLoading style={{ color: '#ea580c' }} /> Cartera de Proveedores & Contratistas
                    </h2>
                    <p>
                        Registro de proveedores de servicios, insumos y contratistas para cotizaciones y órdenes de pago.
                    </p>
                </div>
                <div className="gestion-tab-actions">
                    <button 
                        type="button" 
                        className="btn-primary-zen"
                        style={{ background: '#ea580c' }}
                        onClick={() => abrirModal()}
                    >
                        <FaPlus /> Nuevo Proveedor
                    </button>
                </div>
            </div>

            {/* Filtros */}
            <div className="gestion-filter-bar">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                    <FaSearch style={{ color: '#94a3b8' }} />
                    <input 
                        type="text"
                        className="gestion-search-input"
                        placeholder="Buscar por proveedor, RFC, especialidad/giro o contacto..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>
            </div>

            {/* Tabla */}
            <div className="gestion-table-wrapper">
                <table className="gestion-zen-table">
                    <thead>
                        <tr>
                            <th>Proveedor / Razón Social</th>
                            <th>Especialidad / Giro</th>
                            <th>RFC / ID Fiscal</th>
                            <th>Contacto Directo</th>
                            <th>Teléfono / WhatsApp</th>
                            <th>Correo Electrónico</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {proveedoresFiltrados.length === 0 ? (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '32px', color: '#94a3b8' }}>
                                    No hay proveedores registrados en la cartera. Haz clic en "Nuevo Proveedor" para agregar uno.
                                </td>
                            </tr>
                        ) : (
                            proveedoresFiltrados.map((prov) => (
                                <tr key={prov.id}>
                                    <td style={{ fontWeight: 700, color: '#0f172a' }}>
                                        {prov.nombre}
                                    </td>
                                    <td>
                                        <span style={{ background: '#f1f5f9', padding: '3px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>
                                            {prov.giro || 'General'}
                                        </span>
                                    </td>
                                    <td>{prov.rfc || <span style={{ color: '#94a3b8' }}>N/A</span>}</td>
                                    <td>{prov.contacto || <span style={{ color: '#94a3b8' }}>-</span>}</td>
                                    <td>
                                        {prov.telefono ? (
                                            <a 
                                                href={`https://wa.me/52${prov.telefono.replace(/\D/g, '')}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={{ color: '#16a34a', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                                            >
                                                <FaWhatsapp /> {prov.telefono}
                                            </a>
                                        ) : (
                                            <span style={{ color: '#94a3b8' }}>-</span>
                                        )}
                                    </td>
                                    <td>{prov.email || <span style={{ color: '#94a3b8' }}>-</span>}</td>
                                    <td>
                                        <div className="row-actions-group">
                                            <button 
                                                type="button" 
                                                className="btn-row-action"
                                                onClick={() => abrirModal(prov)}
                                                title="Editar Proveedor"
                                            >
                                                <FaEdit /> Editar
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn-row-action delete"
                                                onClick={() => onEliminarProveedor(prov.id)}
                                                title="Eliminar de la cartera"
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal para Agregar/Editar Proveedor */}
            {modalAbierto && (
                <div className="modal-sendgrid-overlay" onClick={() => setModalAbierto(false)}>
                    <div className="modal-sendgrid-container" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-sendgrid-header modal-header-proveedores">
                            <h3 className="modal-sendgrid-title modal-title-proveedores">
                                <FaTruckLoading style={{ color: '#ea580c' }} /> {proveedorEditando ? 'Editar Proveedor' : 'Nuevo Proveedor'}
                            </h3>
                            <button type="button" className="modal-sendgrid-close" onClick={() => setModalAbierto(false)}>
                                <FaTimes />
                            </button>
                        </div>
                        <form onSubmit={handleGuardar}>
                            <div className="modal-sendgrid-body">
                                <div className="mini-form-grid">
                                    <div className="mini-form-full sendgrid-input-group">
                                        <label>Nombre o Razón Social *</label>
                                        <input 
                                            type="text" 
                                            required
                                            className="sendgrid-input-control"
                                            value={formProveedor.nombre}
                                            onChange={(e) => setFormProveedor({ ...formProveedor, nombre: e.target.value })}
                                            placeholder="Ej. Soluciones Hidráulicas y Bombas S.A. de C.V."
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                            <label style={{ margin: 0 }}>Giro o Especialidad</label>
                                            <div style={{ display: 'flex', gap: '4px' }}>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setEditandoGiroIndex(null);
                                                        setNuevoGiroTexto('');
                                                        setMostrarNuevoGiro(!mostrarNuevoGiro);
                                                    }}
                                                    style={{
                                                        background: '#ea580c',
                                                        color: '#ffffff',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        padding: '2px 6px',
                                                        fontSize: '11px',
                                                        fontWeight: 600,
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '3px'
                                                    }}
                                                    title="Agregar nuevo giro"
                                                >
                                                    <FaPlus /> Nuevo
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handleIniciarEdicionGiro}
                                                    style={{
                                                        background: '#f1f5f9',
                                                        color: '#334155',
                                                        border: '1px solid #cbd5e1',
                                                        borderRadius: '4px',
                                                        padding: '2px 6px',
                                                        fontSize: '11px',
                                                        cursor: 'pointer'
                                                    }}
                                                    title="Editar este giro"
                                                >
                                                    <FaEdit />
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handleEliminarGiroSeleccionado}
                                                    style={{
                                                        background: '#fef2f2',
                                                        color: '#ef4444',
                                                        border: '1px solid #fecaca',
                                                        borderRadius: '4px',
                                                        padding: '2px 6px',
                                                        fontSize: '11px',
                                                        cursor: 'pointer'
                                                    }}
                                                    title="Eliminar este giro del catálogo"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </div>

                                        {/* Input inline si el usuario presiona "Nuevo" o "Editar" */}
                                        {mostrarNuevoGiro && (
                                            <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', background: '#fff7ed', padding: '6px', borderRadius: '6px', border: '1px solid #fed7aa' }}>
                                                <input
                                                    type="text"
                                                    className="sendgrid-input-control"
                                                    placeholder="Nombre de la especialidad / giro..."
                                                    value={nuevoGiroTexto}
                                                    onChange={(e) => setNuevoGiroTexto(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            handleConfirmarGiro();
                                                        }
                                                    }}
                                                    style={{ flex: 1, height: '32px', fontSize: '12px' }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={handleConfirmarGiro}
                                                    style={{ background: '#ea580c', color: '#ffffff', border: 'none', borderRadius: '4px', padding: '0 10px', fontSize: '11px', fontWeight: 700, cursor: 'pointer' }}
                                                >
                                                    {editandoGiroIndex !== null ? 'Actualizar' : 'Guardar'}
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setMostrarNuevoGiro(false)}
                                                    style={{ background: '#e2e8f0', color: '#475569', border: 'none', borderRadius: '4px', padding: '0 6px', fontSize: '11px', cursor: 'pointer' }}
                                                >
                                                    <FaTimes />
                                                </button>
                                            </div>
                                        )}

                                        <select 
                                            className="sendgrid-input-control"
                                            value={formProveedor.giro}
                                            onChange={(e) => setFormProveedor({ ...formProveedor, giro: e.target.value })}
                                            style={{ fontWeight: 600, color: '#0f172a' }}
                                        >
                                            <option value="">-- Seleccionar Giro o Especialidad --</option>
                                            {girosStock.map(g => (
                                                <option key={g} value={g}>{g}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>RFC / Identificador</label>
                                        <input 
                                            type="text" 
                                            className="sendgrid-input-control"
                                            value={formProveedor.rfc}
                                            onChange={(e) => setFormProveedor({ ...formProveedor, rfc: e.target.value })}
                                            placeholder="SHB980101XYZ"
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>Contacto / Asesor</label>
                                        <input 
                                            type="text" 
                                            className="sendgrid-input-control"
                                            value={formProveedor.contacto}
                                            onChange={(e) => setFormProveedor({ ...formProveedor, contacto: e.target.value })}
                                            placeholder="Ing. Carlos Morales"
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>Teléfono / WhatsApp</label>
                                        <input 
                                            type="tel" 
                                            className="sendgrid-input-control"
                                            value={formProveedor.telefono}
                                            onChange={(e) => setFormProveedor({ ...formProveedor, telefono: e.target.value })}
                                            placeholder="442 555 1234"
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>Correo Electrónico</label>
                                        <input 
                                            type="email" 
                                            className="sendgrid-input-control"
                                            value={formProveedor.email}
                                            onChange={(e) => setFormProveedor({ ...formProveedor, email: e.target.value })}
                                            placeholder="ventas@proveedor.com"
                                        />
                                    </div>
                                    <div className="mini-form-full sendgrid-input-group">
                                        <label>Dirección / Ubicación</label>
                                        <input 
                                            type="text" 
                                            className="sendgrid-input-control"
                                            value={formProveedor.direccion}
                                            onChange={(e) => setFormProveedor({ ...formProveedor, direccion: e.target.value })}
                                            placeholder="Parque Industrial Benito Juárez, Nave 4"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-sendgrid-footer">
                                <button type="button" className="btn-modal-cancel" onClick={() => setModalAbierto(false)}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn-modal-send btn-save-proveedores">
                                    Guardar Proveedor
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CarteraProveedoresTab;
